import { AxiosResponse } from 'axios';
import httpRequest, { API_ROUTES } from '@/lib/http/httpRequest';
import {
    AddAccountPayload,
    AddAccountResponse,
    ExchangeAccount,
    UpdateAccountPayload,
} from '@/state/exchanges/exchangesSliceTypes';
import { ApiKeysCountWithUpdates } from '@/state/leaderboard/leaderboardTypes';
import { EXCHANGES } from '@/lib/types/generalTypes';

interface MarkFavPayload {
    accountId: number;
    favoriteStatus: boolean;
}

export interface DeleteAccountPayload {
    accountId: number;
}

interface GetAccountByIdPayload {
    accountId: number;
}

interface GetHyperliquidAccountById {
    accountId: number;
    payload: {
        selectedExchange: EXCHANGES;
    };
}

export const addNewAccount = (
    payload: AddAccountPayload,
): Promise<AxiosResponse<AddAccountResponse>> =>
    httpRequest.post(`${API_ROUTES.API_MANAGER}/exchanges/${payload.selectedExchange}`, payload);

export const updateAccountApi = (
    payload: UpdateAccountPayload,
): Promise<AxiosResponse<ExchangeAccount>> =>
    httpRequest.put(
        `${API_ROUTES.API_MANAGER}/exchanges/${payload.selectedExchange}/${payload.id}`,
        payload,
    );

export const deleteAccount = (payload: DeleteAccountPayload): Promise<AxiosResponse<void>> =>
    httpRequest.delete(`${API_ROUTES.API_MANAGER}/${payload.accountId}`);

export const markAsFavorite = ({
    accountId,
    favoriteStatus,
}: MarkFavPayload): Promise<AxiosResponse<ExchangeAccount>> =>
    httpRequest.put(`${API_ROUTES.MARK_FAVORITE}/${accountId}`, { favoriteStatus });

export const getHyperliquidAccountById = ({
    accountId,
    payload,
}: GetHyperliquidAccountById): Promise<AxiosResponse<ExchangeAccount>> =>
    httpRequest.get(`${API_ROUTES.API_MANAGER}/exchanges/${payload.selectedExchange}/${accountId}`);

export const getAccountById = ({
    accountId,
}: GetAccountByIdPayload): Promise<AxiosResponse<ExchangeAccount>> =>
    httpRequest.get(`${API_ROUTES.API_MANAGER}/${accountId}`);

export const getAllAccounts = (): Promise<AxiosResponse<AddAccountResponse[]>> =>
    httpRequest.get(API_ROUTES.API_MANAGER);

export const updateApiKeySettings = ({ id, ...rest }): Promise<AxiosResponse<any>> =>
    httpRequest.put(`${API_ROUTES.API_MANAGER}/${id}/settings`, rest);

export const getApiKeysCount = (): Promise<AxiosResponse<ApiKeysCountWithUpdates>> =>
    httpRequest.get(`${API_ROUTES.API_MANAGER}/count-all`);
